import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=05e0710f&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=05e0710f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e0710f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e0710f')) {
      api.createRecord('05e0710f', component.options)
    } else {
      api.reload('05e0710f', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=05e0710f&scoped=true&", function () {
      api.rerender('05e0710f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gb6AQX6ppaYw/JS/comp/DateRangeExt.vue"
export default component.exports